import React, { FunctionComponent } from 'react'

export const Debugger: FunctionComponent<any> = (props) => <span>{JSON.stringify(props)}</span>

Debugger.displayName = 'Debugger'
